import { useContext, useState } from "react"
import { LOGO_URL } from "../utils/constants"
import { Link } from "react-router-dom"
import useOnlineStatus from "../utils/useOnlineStatus"
import DarkModeToggle from "./DarkModeToggle"
import UserContext from "./UserContext"
import { useSelector } from "react-redux"
const Header = () => {
  const [btnName, setBtnName] = useState("LogIn")
  // const [darkMode,setDarkMode]=useState(false)
  // const toggleMode=()=>{
  //   setDarkMode(!darkMode);
  // }
  // useEffect(()=>{
  //   if (darkMode) {
  //     document.documentElement.classList.add('dark');
  //   } else {
  //     document.documentElement.classList.remove('dark');
  //   }
  // },[darkMode])
  const onlineStatus = useOnlineStatus()
  console.log("render head!")
  const {loggedInUser}=useContext(UserContext)
 //console.log("name",loggedInUser)

 const cartItems=useSelector(store=>store.cart.items)
 console.log("carItems: ",cartItems);

  //sm for set color of header when screen size is at least 640 px . lg for set color when size is above around 1000 px
  // sm:bg-slate-500 lg:bg-rose-600
  return (
    <div className="flex justify-between bg-slate-800  p-1 shadow-black  ">
      <div className="logo-container">
        {/* <img src="./images/ResLogo.jpg" /> */}
        <img className="w-28" src={LOGO_URL} alt="logo" />
      </div>
      <div className="nav-items">
        <ul className="flex p-4 m-4">
        <li><DarkModeToggle/> </li>
          {/* windows+ ; for emoji */}
          <li className="m-4 ">{onlineStatus ? "🟢" : "🔴"}</li>
          <li className="m-4 p-2 rounded-lg border-dotted text-yellow-500 hover:bg-white">
            <Link to="/">Home</Link>
          </li>
          <li className="m-4 p-2 rounded-lg border-dotted text-yellow-500 hover:bg-white">
            <Link to="/restaurants">Restaurants</Link>
          </li>
          <li className="m-4 p-2 rounded-lg border-dotted text-yellow-500 hover:bg-white">
            <Link to="/grocery">Grocery</Link>
          </li>
          <li className="m-4 p-2 rounded-lg border-dotted text-yellow-500 hover:bg-white">
            <Link to="/about">About Us</Link>
          </li>
          <li className="m-4 p-2 rounded-lg border-dotted text-yellow-500 hover:bg-white">
            <Link to="/contact">Contact Us</Link>
          </li>

          <li className="m-4 p-2 rounded-lg border-dotted text-yellow-500 hover:bg-white">
            <Link to="/cart">Cart- {cartItems.length}</Link>
          </li>
          <li className="m-4 p-2 rounded-lg border-dotted text-yellow-500 hover:bg-white">
            <button
              className="btn"
              onClick={() => {
                if (btnName == "LogIn") setBtnName("LogOut")
                else setBtnName("LogIn")
              }}
            >
              {btnName}
            </button>
          </li>
          <li className="m-4 p-2 rounded-lg border-dotted text-yellow-500 hover:bg-white">
            <h1>{loggedInUser}</h1>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Header
